module.exports = __webpack_public_path__ + "img/Home_Desktop_05.5f2c120c.jpg";